import styled, { css } from 'styled-components';

interface StyledDropdownListProps {
  $size: 'large' | 'medium' | 'small';
  $searchFieldHeight: string;
  $maxHeight: string;
  $direction: 'top' | 'bottom';
}

export const StyledDropdownList = styled.div<StyledDropdownListProps>`
  & > .dropdown-list {
    box-sizing: border-box;
    pointer-events: all;
    width: 100%;
    height: max-content;
    max-height: ${({ $maxHeight }) => $maxHeight};
    overflow: hidden;
    position: absolute;
    left: 0;

    background-color: var(--bg-gray-normal);
    border-radius: 0.4rem;
    border: 0.1rem solid var(--bg-gray-2);
    cursor: default;
    ${({ $direction }) =>
      $direction === 'top'
        ? css`
            bottom: calc(100% + 0.2rem);
          `
        : css`
            top: calc(100% + 0.2rem);
          `}
    /* & > .search-area {
      position: absolute;
      width: calc(100% - 0.8rem);
      height: max-content;
      padding: 0.4rem;
      & > input[type="text"] {
        border: none;
        outline: none;
        padding: 0;
        background: var(--bg-gray-normal);
        pointer-events: none;
        font: ${({ $size }) =>
      $size === 'large'
        ? 'var(--body-medium-400)'
        : $size === 'medium'
          ? 'var(--body-small-400)'
          : 'var(--label-small-400)'};
        color: var(--text-gray-strong);
        &::placeholder {
          color: var(--text-gray-4);
        }
      }
    } */
    & > .search-input {
      border: none;
      outline: none;
      padding: 0;
      background: var(--bg-gray-normal);
      /* pointer-events: none; */
      font: ${({ $size }) =>
        $size === 'large'
          ? 'var(--body-medium-400)'
          : $size === 'medium'
            ? 'var(--body-small-400)'
            : 'var(--label-small-400)'};
      color: var(--text-gray-strong);
      &::placeholder {
        color: var(--text-gray-4);
      }
    }
    & > .list-area {
      /* padding: 0.4rem 0;  */
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-use-select: none;
      user-select: none;
      overflow-y: auto;
      padding: 0.4rem 0;
      /* max-height: ${({ $maxHeight }) => $maxHeight}; */
      /* max-height: ${({ $searchFieldHeight }) => `calc(20rem - ${$searchFieldHeight})`}; */

      & > .message {
        pointer-events: none;
        box-sizing: border-box;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        gap: 0.4rem;
        padding: ${({ $size }) => ($size === 'large' ? '0.8rem' : '0.4rem 0.8rem')};
        width: 100%;
        height: max-content;
        cursor: default;
        background-color: var(--bg-gray-normal);
        & > .label {
          color: var(--bg-gray-4);
          font: ${({ $size }) =>
            $size === 'large'
              ? 'var(--body-large-400)'
              : $size === 'medium'
                ? 'var(--body-small-400)'
                : 'var(--label-small-400)'};
        }
      }
    }
  }
`;
